import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function useLocalizedMeta() {
  const { i18n } = useTranslation();
  const lang = (i18n.language ?? "en").split("-")[0];

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
}